/*
 * HVM onderdelenzoeker, premium versie.
 * Kenteken, snelzoeken en kiezen in stappen (merk, model, bouwjaar), daarna alle passende onderdelen
 * met categorieen, filters, uitvoering, universele onderdelen en "niet gevonden".
 * Leest dezelfde index als de gewone zoeker (pf-brands.json + pf-b-<merk>.json, of pf-all.json)
 * en deelt de opgeslagen motor, zodat de pasmelding op de productpagina meewerkt.
 */
(function () {
  'use strict';

  var STORE_KEY = 'hvmPartfinderMotor';
  var GARAGE_KEY = 'hvmPartfinderGarage';
  var GARAGE_MAX = 5;
  var PAGE = 24;
  var POPULAR = ['Yamaha', 'Kawasaki', 'Honda', 'Suzuki', 'KTM', 'Ducati', 'BMW', 'Aprilia', 'Triumph', 'Husqvarna', 'MV Agusta', 'GASGAS'];
  var RDW_URL = 'https://opendata.rdw.nl/resource/m9d7-ebf2.json';
  var RDW_COLORS = { ZWART: '#1b1b1b', WIT: '#f4f4f4', GRIJS: '#8a8d91', ROOD: '#d7262b', BLAUW: '#1f55b8', GROEN: '#2f8a3a', GEEL: '#f2c200', ORANJE: '#f07c12', BRUIN: '#6f4a2a', BEIGE: '#d9c7a5', PAARS: '#6b3fa0', ROSE: '#e98bb0', CREME: '#efe6cf' };
  var cache = {};

  /* ---------- opslag ---------- */
  function same(a, b) { return !!(a && b && a.brand === b.brand && a.model === b.model && String(a.year || '') === String(b.year || '')); }
  function readJson(k, d) { try { return JSON.parse(localStorage.getItem(k) || 'null') || d; } catch (e) { return d; } }
  function writeJson(k, v) { try { if (v == null) localStorage.removeItem(k); else localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function garage() { return readJson(GARAGE_KEY, []).filter(function (m) { return m && m.brand && m.model; }); }
  function remember(val) {
    var m = { brand: val.brand, model: val.model, year: val.year || '' };
    if (val.v) m.v = val.v;
    writeJson(STORE_KEY, m);
    writeJson(GARAGE_KEY, [m].concat(garage().filter(function (x) { return !same(x, m); })).slice(0, GARAGE_MAX));
  }
  function forget(m) {
    var g = garage().filter(function (x) { return !same(x, m); });
    writeJson(GARAGE_KEY, g);
    if (same(readJson(STORE_KEY, null), m)) writeJson(STORE_KEY, g[0] || null);
  }

  /* ---------- index ---------- */
  function loadJson(url) {
    if (!cache[url]) cache[url] = fetch(url, { credentials: 'omit' }).then(function (r) { if (!r.ok) throw new Error('index ' + r.status); return r.json(); });
    return cache[url];
  }
  function assetUrl(base, file) { return base.replace(/pf-[a-z]+\.json/, file).replace(/\?.*$/, ''); }
  function entriesFor(d, m) {
    var rows = d.models[m.model] || [], y = parseInt(m.year, 10), out = {};
    rows.forEach(function (r) {
      if (!(r.length === 1 || !y || (r[1] <= y && y <= r[2]))) return;
      var restr = (r.length === 4 && y) ? r[3] : null;
      if (out[r[0]] === null) return;
      if (restr === null) { out[r[0]] = null; return; }
      out[r[0]] = (out[r[0]] || []).concat(restr);
    });
    (d.brandwide || []).forEach(function (i) { out[i] = null; });
    return out;
  }

  /* ---------- hulpjes ---------- */
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  function svg(path, cls) { var s = '<svg class="' + (cls || 'pfx-i') + '" viewBox="0 0 24 24" aria-hidden="true">' + path + '</svg>'; var t = document.createElement('span'); t.innerHTML = s; return t.firstChild; }
  var I = {
    search: '<circle cx="10.5" cy="10.5" r="6.5"/><path d="m15.5 15.5 5 5"/>',
    check: '<path d="m5 12.5 4.5 4.5L19 7.5"/>',
    back: '<path d="M15 5l-7 7 7 7"/>',
    arrow: '<path d="M5 12h14M13 6l6 6-6 6"/>',
    x: '<path d="M6 6l12 12M18 6 6 18"/>',
    plus: '<path d="M12 5v14M5 12h14"/>',
    share: '<path d="M8.5 13.5 15.5 17.5M15.5 6.5l-7 4"/><circle cx="18" cy="5" r="2.5"/><circle cx="6" cy="12" r="2.5"/><circle cx="18" cy="19" r="2.5"/>',
    filter: '<path d="M4 6h16M7 12h10M10 18h4"/>',
    edit: '<path d="M4 20h4L19 9l-4-4L4 16z"/>',
    wa: '<path d="M4 20l1.3-4A8 8 0 1 1 8.3 19z"/><path d="M9 8.5c0 3.5 3 6.5 6.5 6.5l1-1.6-2-1-1 .8a5 5 0 0 1-2.8-2.8l.8-1-1-2z"/>',
    mail: '<rect x="3" y="5.5" width="18" height="13" rx="2"/><path d="m4 7 8 6 8-6"/>',
    truck: '<path d="M3 6.5h11v9H3zM14 9.5h4l3 3v3h-7"/><circle cx="7" cy="17" r="1.8"/><circle cx="17" cy="17" r="1.8"/>',
    chat: '<path d="M5 18.5 3.5 21V6a2 2 0 0 1 2-2h13a2 2 0 0 1 2 2v9.5a2 2 0 0 1-2 2z"/><path d="M8 9.5h8M8 13h5"/>',
    chev: '<path d="m6 9 6 6 6-6"/>',
    shield: '<path d="M12 3 5 6v5.5c0 4.3 2.9 8 7 9.5 4.1-1.5 7-5.2 7-9.5V6z"/><path d="m9 12 2 2 4-4"/>'
  };
  function money(v, loc, cur) {
    if (v == null || isNaN(v)) return '';
    try { return new Intl.NumberFormat(loc, { style: 'currency', currency: cur || 'EUR' }).format(v); } catch (e) { return '€ ' + Number(v).toFixed(2).replace('.', ','); }
  }
  function imgUrl(src, w) { if (!src) return ''; src = src.replace(/^https?:/, ''); return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function fmt(s, o) { return String(s || '').replace(/\{(\w+)\}/g, function (_, k) { return o[k] != null ? o[k] : ''; }); }
  function normTxt(x) { return String(x || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase(); }
  function tokens(x) { return normTxt(x).split(/[^A-Z0-9]+/).filter(Boolean); }
  function squash(x) { return normTxt(x).replace(/[^A-Z0-9]/g, ''); }
  function label(m) { return [m.brand, m.model, m.year || ''].join(' ').trim(); }
  function natural(a, b) { return String(a).localeCompare(String(b), undefined, { numeric: true, sensitivity: 'base' }); }
  function yearsTxt(ys) { return ys.length ? (ys[0] === ys[ys.length - 1] ? String(ys[0]) : ys[0] + '–' + ys[ys.length - 1]) : ''; }

  /* ---------- categorieen ---------- */
  var GROUPS = [
    { id: 'remmen', re: /brake|\brem|remblok|remschijf|remklauw|rempomp|\bdisc\b|\bpads?\b|caliper|master cyl|bremse/i, nl: 'Remmen', de: 'Bremsen', en: 'Brakes' },
    { id: 'uitlaat', re: /exhaust|uitlaat|silencer|slip-on|header|link pipe|mid pipe|demper|auspuff/i, nl: 'Uitlaten', de: 'Auspuff', en: 'Exhausts' },
    { id: 'bescherming', re: /protect|slider|crash|guard|case saver|bescherm|bobbin|spool|schutz/i, nl: 'Bescherming', de: 'Schutz', en: 'Protection' },
    { id: 'bediening', re: /rearset|lever|hendel|clip-on|footpeg|voetsteun|shift|schakel|stuur|handlebar|triple|kroonplaat|grip|reverse|preload|remote adjust|holeshot|launch/i, nl: 'Bediening', de: 'Bedienung', en: 'Controls' },
    { id: 'aandrijving', re: /chain|ketting|sprocket|tandwiel|kettingspanner|adjuster|kette|ritzel/i, nl: 'Aandrijving', de: 'Antrieb', en: 'Drivetrain' },
    { id: 'accu', re: /\baccu|batter/i, nl: "Accu's", de: 'Batterien', en: 'Batteries' },
    { id: 'banden', re: /motorband|\bband\b|tyre|tire|reifen|voorband|achterband/i, nl: 'Banden', de: 'Reifen', en: 'Tyres' },
    { id: 'doppen', re: /\bcaps?\b|\bdop\b|tankdop|oliedop|deckel/i, nl: 'Doppen & deksels', de: 'Deckel', en: 'Caps & covers' },
    { id: 'onderhoud', re: /olie|\boil\b|smeer|onderhoud|clean|reinig|lube|fett/i, nl: 'Onderhoud', de: 'Wartung', en: 'Maintenance' },
    { id: 'carbon', re: /carbon/i, nl: 'Carbon', de: 'Carbon', en: 'Carbon' }
  ];
  var OTHER = { id: 'overig', nl: 'Overige', de: 'Weitere', en: 'Other' };
  function groupOf(p) {
    if (p._g) return p._g;
    for (var i = 0; i < GROUPS.length; i++) if (GROUPS[i].re.test(p[3] || '')) return (p._g = GROUPS[i].id);
    var s = (p[3] || '') + ' ' + p[1];
    for (var j = 0; j < GROUPS.length; j++) if (GROUPS[j].re.test(s)) return (p._g = GROUPS[j].id);
    return (p._g = OTHER.id);
  }
  function groupName(id, lg) { var g = GROUPS.filter(function (x) { return x.id === id; })[0] || OTHER; return g[lg] || g.nl; }

  // Modelreeks voor het groeperen: CBR 600 RR -> CBR, MT-07 -> MT, 1290 Super Duke R -> Duke
  function family(name) {
    var t = name.split(/\s+/);
    if (/^[A-Za-z]/.test(t[0])) return t[0].match(/^[A-Za-z]+/)[0];
    var words = t.slice(1).map(function (w) { return (w.match(/^[A-Za-z]+/) || [''])[0]; }).filter(function (w) { return w.length > 1; });
    words.sort(function (a, b) { return b.length - a.length; });
    return words[0] || '#';
  }

  // Filters uit de productopties (namen staan in het Nederlands in de index)
  var OPT_ORDER = ['Lengte', 'Aantal tanden', 'Diameter remschijf', 'Remschijf', 'Stuur binnendiameter', 'Klemdiameter', 'Clip-on type', 'Zijde', 'Maat', 'Uitvoering', 'Carbon', 'Afwerking', 'Design', 'Systeem', 'Koplamp', 'Hoogte'];
  var OPT_LABEL = {
    'Lengte': { de: 'Länge', en: 'Length' }, 'Aantal tanden': { de: 'Zähnezahl', en: 'Number of teeth' }, 'Diameter remschijf': { de: 'Bremsscheibendurchmesser', en: 'Brake disc diameter' },
    'Remschijf': { de: 'Bremsscheibe', en: 'Brake disc' }, 'Stuur binnendiameter': { de: 'Lenker-Innendurchmesser', en: 'Handlebar inner diameter' }, 'Klemdiameter': { de: 'Klemmdurchmesser', en: 'Clamp diameter' },
    'Clip-on type': { de: 'Lenkerstummel-Typ', en: 'Clip-on type' }, 'Zijde': { de: 'Seite', en: 'Side' }, 'Maat': { de: 'Größe', en: 'Size' }, 'Uitvoering': { de: 'Ausführung', en: 'Version' },
    'Carbon': { de: 'Carbon', en: 'Carbon' }, 'Afwerking': { de: 'Oberfläche', en: 'Finish' }, 'Design': { de: 'Design', en: 'Design' }, 'Systeem': { de: 'System', en: 'System' },
    'Koplamp': { de: 'Scheinwerfer', en: 'Headlight' }, 'Hoogte': { de: 'Höhe', en: 'Height' }, 'Verpakking': { de: 'Verpackung', en: 'Pack' }, 'Schroefdraad': { de: 'Gewinde', en: 'Thread' }
  };
  function optLabel(n, lg) { return (OPT_LABEL[n] && OPT_LABEL[n][lg]) || n; }

  /* ======================================================================= */

  function App(root) {
    var t = {}; try { t = JSON.parse(root.querySelector('[data-pfx-t]').textContent); } catch (e) {}
    if (!t.sale) t.sale = { de: 'Nur Angebote', en: 'On sale only' }[(root.dataset.locale || 'nl').slice(0, 2)] || 'Alleen aanbiedingen';
    var ds = root.dataset;
    var lg = (ds.locale || 'nl').slice(0, 2);
    var mode = ds.mode || 'full';
    var base = ds.assetBase;
    var $ = function (s) { return root.querySelector(s); };
    var fast = $('[data-pfx-fast]'), msg = $('[data-pfx-msg]'), gar = $('[data-pfx-garage]'), wiz = $('[data-pfx-wizard]'), res = $('[data-pfx-results]');
    var idx = null, brands = [], sel = { brand: '', model: '', year: '' };
    var ready = loadJson(base).then(function (x) { idx = x; brands = x.brands; return x; });

    function brandInfo(name) { for (var i = 0; i < brands.length; i++) if (brands[i].b === name) return brands[i]; return null; }
    function brandData(b) { return idx.data ? Promise.resolve(idx.data[b.b]) : loadJson(assetUrl(base, b.f)); }
    function universal() { return idx.universal ? Promise.resolve(idx.universal) : loadJson(assetUrl(base, 'pf-universal.json')); }
    function track(name, data) {
      data = Object.assign({ event: name, page: location.pathname, ts: Date.now(), ui: 'premium' }, data);
      try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('partfinder_' + name, data); } catch (e) {}
      try { (window.dataLayer = window.dataLayer || []).push(Object.assign({}, data, { event: 'partfinder_' + name })); } catch (e) {}
      if (ds.trackerUrl) { try { navigator.sendBeacon(ds.trackerUrl, new Blob([JSON.stringify(data)], { type: 'text/plain' })); } catch (e) {} }
    }
    function say(text, kind, color) {
      msg.innerHTML = ''; msg.hidden = !text; msg.dataset.kind = kind || '';
      if (!text) return;
      if (color) { var dot = el('span', 'pfx-msg__dot'); dot.style.background = color; msg.appendChild(dot); }
      msg.appendChild(el('span', null, text));
    }
    function resultsUrl(m) {
      var p = new URLSearchParams(); p.set('merk', m.brand); p.set('model', m.model);
      if (m.year) p.set('jaar', m.year); if (m.v) p.set('uitv', m.v);
      var u = ds.resultsUrl || location.pathname;
      return u + (u.indexOf('?') > -1 ? '&' : '?') + p.toString();
    }

    /* ---------- snel: kenteken + zoeken ---------- */
    function buildFast() {
      var plate = el('form', 'pfx-plate'); plate.noValidate = true;
      var lab = el('label', 'pfx-plate__label');
      lab.appendChild(el('span', 'pfx-plate__hint', t.plateHint));
      var field = el('span', 'pfx-plate__field');
      field.appendChild(el('span', 'pfx-plate__nl', 'NL'));
      var inp = el('input', 'pfx-plate__input'); inp.type = 'text'; inp.placeholder = 'AB-123-C'; inp.maxLength = 10;
      inp.setAttribute('autocomplete', 'off'); inp.setAttribute('autocapitalize', 'characters'); inp.spellcheck = false; inp.setAttribute('aria-label', t.plateLabel);
      field.appendChild(inp); lab.appendChild(field); plate.appendChild(lab);
      var go = el('button', 'pfx-btn pfx-btn--red', t.plateGo); go.type = 'submit'; plate.appendChild(go);
      inp.addEventListener('input', function () { inp.value = inp.value.toUpperCase().replace(/[^A-Z0-9-]/g, ''); });
      plate.addEventListener('submit', function (e) { e.preventDefault(); lookupPlate(inp.value); });

      var or = el('div', 'pfx-or'); or.appendChild(el('span', null, t.or));

      var q = el('div', 'pfx-q');
      q.appendChild(svg(I.search, 'pfx-i pfx-q__icon'));
      var qi = el('input', 'pfx-q__input'); qi.type = 'search'; qi.placeholder = t.qPlaceholder; qi.setAttribute('aria-label', t.qPlaceholder);
      qi.setAttribute('role', 'combobox'); qi.setAttribute('aria-expanded', 'false'); qi.setAttribute('autocomplete', 'off'); qi.id = 'pfx-q-' + Math.random().toString(36).slice(2, 7);
      var list = el('ul', 'pfx-sugg'); list.hidden = true; list.setAttribute('role', 'listbox'); list.id = qi.id + '-l'; qi.setAttribute('aria-controls', list.id);
      q.appendChild(qi); q.appendChild(list);
      fast.appendChild(plate); fast.appendChild(or); fast.appendChild(q);
      initQuick(qi, list);
    }

    function initQuick(input, list) {
      var all = null, items = [], active = -1;
      ready.then(function () {
        all = [];
        brands.forEach(function (b) { var bs = squash(b.b); b.m.forEach(function (m) { all.push({ b: b.b, m: m[0], years: m[1], sq: squash(m[0]), full: bs + squash(m[0]), tk: tokens(b.b + ' ' + m[0]) }); }); });
      });
      function score(it, q, qt) {
        if (it.sq === q || it.full === q) return 100;
        if (it.sq.indexOf(q) === 0) return 80 - it.sq.length / 10;
        if (it.full.indexOf(q) === 0) return 70 - it.full.length / 10;
        if (qt.length > 1 && qt.every(function (w) { return it.tk.some(function (x) { return x.indexOf(w) === 0; }); })) return 60 - it.sq.length / 10;
        if (it.sq.indexOf(q) > -1) return 40 - it.sq.length / 10;
        return 0;
      }
      function close() { list.hidden = true; input.setAttribute('aria-expanded', 'false'); }
      function render() {
        list.innerHTML = '';
        items.forEach(function (it, i) {
          var li = el('li', 'pfx-sugg__item' + (i === active ? ' is-active' : '')); li.setAttribute('role', 'option'); li.id = input.id + '-o' + i;
          var tx = el('span', 'pfx-sugg__txt'); tx.appendChild(el('b', null, it.b)); tx.appendChild(document.createTextNode(' ' + it.m));
          li.appendChild(tx);
          if (it.years.length) li.appendChild(el('span', 'pfx-sugg__years', yearsTxt(it.years)));
          li.appendChild(svg(I.arrow, 'pfx-i pfx-sugg__go'));
          li.addEventListener('mousedown', function (e) { e.preventDefault(); pick(i); });
          list.appendChild(li);
        });
        var long = input.value.trim().length >= 2;
        if (!items.length && long) list.appendChild(el('li', 'pfx-sugg__none', t.qNone));
        list.hidden = !long; input.setAttribute('aria-expanded', list.hidden ? 'false' : 'true');
        if (active > -1) input.setAttribute('aria-activedescendant', input.id + '-o' + active); else input.removeAttribute('aria-activedescendant');
      }
      function search() {
        var q = squash(input.value), qt = tokens(input.value); active = -1;
        if (q.length < 2 || !all) { items = []; render(); return; }
        items = all.map(function (it) { return { it: it, s: score(it, q, qt) }; }).filter(function (x) { return x.s > 0; })
          .sort(function (a, b) { return b.s - a.s || natural(a.it.b, b.it.b) || natural(a.it.m, b.it.m); }).slice(0, 7).map(function (x) { return x.it; });
        render();
      }
      function pick(i) {
        var it = items[i]; if (!it) return;
        input.value = ''; close();
        track('quick', { brand: it.b, model: it.m });
        sel = { brand: it.b, model: it.m, year: '' };
        if (!it.years.length) finish(); else show('year');
        scrollToCard();
      }
      input.addEventListener('input', search);
      input.addEventListener('focus', function () { if (input.value) search(); });
      input.addEventListener('blur', function () { setTimeout(close, 150); });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') { e.preventDefault(); active = Math.min(items.length - 1, active + 1); render(); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); active = Math.max(0, active - 1); render(); }
        else if (e.key === 'Enter') { e.preventDefault(); pick(active > -1 ? active : 0); }
        else if (e.key === 'Escape') close();
      });
    }

    function matchModel(brand, rdwName, aliases) {
      var bs = squash(brand.b), tk = tokens(rdwName).filter(function (w) { return w !== bs; }), sq = tk.join(''), al = aliases || {};
      var keys = Object.keys(al).sort(function (a, b) { return b.length - a.length; });
      for (var i = 0; i < keys.length; i++) if (sq.indexOf(keys[i]) === 0) { var hit = brand.m.filter(function (m) { return m[0] === al[keys[i]]; })[0]; if (hit) return hit; }
      var win = {};
      for (var a = 0; a < tk.length; a++) { var w = ''; for (var b = a; b < tk.length; b++) { w += tk[b]; win[w] = 1; } }
      var best = null, len = 0;
      brand.m.forEach(function (m) {
        var mt = tokens(m[0]), ms = mt.join('');
        var ok = win[ms] || (mt.length > 1 && mt.every(function (x) { return tk.indexOf(x) > -1; }));
        if (ok && ms.length > len) { best = m; len = ms.length; }
      });
      return best;
    }
    function nearestYear(ys, y) {
      if (!ys.length || !y) return '';
      if (ys.indexOf(y) > -1) return y;
      var best = ys[0]; ys.forEach(function (x) { if (Math.abs(x - y) < Math.abs(best - y)) best = x; });
      return Math.abs(best - y) <= 1 ? best : '';
    }
    function lookupPlate(raw) {
      var plate = String(raw || '').replace(/[^A-Z0-9]/gi, '').toUpperCase();
      if (plate.length < 4 || plate.length > 8) { say(t.plateInvalid, 'error'); return; }
      say(t.plateBusy, 'busy');
      fetch(RDW_URL + '?kenteken=' + encodeURIComponent(plate), { credentials: 'omit' })
        .then(function (r) { if (!r.ok) throw new Error('rdw'); return r.json(); })
        .then(function (rows) {
          var v = rows && rows[0];
          if (!v) { say(t.plateNotFound, 'error'); track('plate', { result: 'onbekend' }); return; }
          var year = parseInt(String(v.datum_eerste_toelating || '').slice(0, 4), 10) || null;
          var color = RDW_COLORS[String(v.eerste_kleur || '').toUpperCase()] || null;
          var rdwLabel = [v.merk, v.handelsbenaming, year || ''].join(' ').trim();
          return ready.then(function () {
            var brand = brands.filter(function (b) { return squash(b.b) === squash(v.merk); })[0];
            if (!brand) { say(fmt(t.plateNoParts, { bike: rdwLabel }), 'info', color); track('plate', { result: 'geen merk', merk: v.merk, model: v.handelsbenaming }); return; }
            var model = matchModel(brand, v.handelsbenaming + ' ' + (v.type || ''), (idx.alias || {})[brand.b]);
            if (!model) { sel = { brand: brand.b, model: '', year: '' }; say(fmt(t.plateChooseModel, { bike: rdwLabel }), 'info', color); show('model'); track('plate', { result: 'geen model', merk: v.merk, model: v.handelsbenaming }); return; }
            var y = nearestYear(model[1], year);
            track('plate', { result: 'gevonden', brand: brand.b, model: model[0], year: y || null });
            sel = { brand: brand.b, model: model[0], year: y ? String(y) : '' };
            if (model[1].length && !y) { say(fmt(t.plateChooseYear, { bike: brand.b + ' ' + model[0] }), 'info', color); show('year'); return; }
            say(t.found + ': ' + label(sel), 'ok', color);
            finish();
          });
        })
        .catch(function () { say(t.plateError, 'error'); });
    }

    /* ---------- mijn motoren ---------- */
    function renderGarage() {
      var g = garage(); gar.innerHTML = ''; gar.hidden = !g.length;
      if (!g.length) return;
      gar.appendChild(el('span', 'pfx-garage__label', t.myBikes));
      g.forEach(function (m, i) {
        var chip = el('span', 'pfx-chip' + (i === 0 ? ' pfx-chip--main' : ''));
        var a = el('a', 'pfx-chip__link'); a.href = resultsUrl(m);
        if (i === 0) { a.appendChild(el('span', 'pfx-chip__pre', t.continue)); }
        a.appendChild(document.createTextNode(label(m)));
        a.addEventListener('click', function (e) { if (mode !== 'full') { remember(m); return; } e.preventDefault(); sel = { brand: m.brand, model: m.model, year: m.year || '', v: m.v }; finish(); });
        var x = el('button', 'pfx-chip__x'); x.type = 'button'; x.setAttribute('aria-label', t.remove + ' ' + label(m)); x.appendChild(svg(I.x));
        x.addEventListener('click', function () { forget(m); renderGarage(); });
        chip.appendChild(a); chip.appendChild(x); gar.appendChild(chip);
      });
    }

    /* ---------- keuzelijsten: merk, model, bouwjaar ---------- */
    var sb, sm, sy, goBtn;
    function selField(lbl, ph) {
      var w = el('label', 'pfx-sel'); w.appendChild(el('span', 'pfx-sel__k', lbl));
      var s = el('select', 'pfx-sel__s'); s.disabled = true; opt(s, '', ph);
      w.appendChild(s); return [w, s];
    }
    function opt(s, v, txt) { var o = el('option', null, txt); o.value = v; s.appendChild(o); return o; }
    function reset(s, ph) { s.innerHTML = ''; opt(s, '', ph); }
    function buildSelects() {
      var row = el('div', 'pfx-pick');
      var a = selField(t.brand, t.pickBrand), b = selField(t.model, t.pickModel), c = selField(t.year, t.pickYear);
      sb = a[1]; sm = b[1]; sy = c[1];
      goBtn = el('button', 'pfx-btn pfx-btn--red pfx-go'); goBtn.type = 'button'; goBtn.disabled = true;
      goBtn.appendChild(el('span', null, t.go)); goBtn.appendChild(svg(I.arrow));
      row.appendChild(a[0]); row.appendChild(b[0]); row.appendChild(c[0]); row.appendChild(goBtn);
      wiz.appendChild(row);
      sb.addEventListener('change', function () { sel = { brand: sb.value, model: '', year: '' }; fillModels(); if (sb.value) sm.focus(); });
      sm.addEventListener('change', function () { sel.model = sm.value; sel.year = ''; fillYears(); if (sm.value && !sy.disabled) sy.focus(); });
      sy.addEventListener('change', function () { sel.year = sy.value === '*' ? '' : sy.value; updGo(); });
      goBtn.addEventListener('click', function () { if (sel.brand && sel.model) finish(); });
    }
    function fillBrands() {
      reset(sb, t.pickBrand);
      var g1 = el('optgroup'); g1.label = t.popularBrands;
      POPULAR.map(brandInfo).filter(Boolean).forEach(function (b) { opt(g1, b.b, b.b); });
      var g2 = el('optgroup'); g2.label = t.allBrands;
      brands.slice().sort(function (a, b) { return natural(a.b, b.b); }).forEach(function (b) { opt(g2, b.b, b.b); });
      sb.appendChild(g1); sb.appendChild(g2);
      sb.value = sel.brand || ''; sb.disabled = false;
    }
    function fillModels() {
      var b = brandInfo(sel.brand);
      reset(sm, t.pickModel); reset(sy, t.pickYear); sy.disabled = true; sm.disabled = !b;
      if (!b) { updGo(); return; }
      var models = b.m.slice();
      function label2(m) { return m[0]; }
      if (models.length > 14) {
        var fams = {};
        models.forEach(function (m) { var f = family(m[0]); (fams[f] = fams[f] || []).push(m); });
        var keys = Object.keys(fams), rest = [];
        keys.forEach(function (k) { if (fams[k].length < 2) { rest = rest.concat(fams[k]); delete fams[k]; } });
        keys = Object.keys(fams).sort(natural);
        if (rest.length) { fams[t.otherModels] = rest; keys.push(t.otherModels); }
        keys.forEach(function (k) {
          var g = el('optgroup'); g.label = k;
          fams[k].sort(function (a, c) { return natural(a[0], c[0]); }).forEach(function (m) { opt(g, m[0], label2(m)); });
          sm.appendChild(g);
        });
      } else {
        models.sort(function (a, c) { return natural(a[0], c[0]); }).forEach(function (m) { opt(sm, m[0], label2(m)); });
      }
      sm.value = sel.model || '';
      if (sel.model && sm.value) fillYears(); else updGo();
    }
    function fillYears() {
      var b = brandInfo(sel.brand), m = b && b.m.filter(function (x) { return x[0] === sel.model; })[0];
      reset(sy, t.pickYear);
      if (!m) { sy.disabled = true; updGo(); return; }
      if (!m[1].length) { reset(sy, t.allYears); sy.disabled = true; updGo(); return; }
      var ys = m[1].slice().sort(function (a, c) { return c - a; });
      ys.forEach(function (y) { opt(sy, y, String(y)); });
      opt(sy, '*', t.yearUnknown);
      sy.disabled = false; sy.value = sel.year || '';
      updGo();
    }
    function updGo() { goBtn.disabled = !(sel.brand && sel.model && (sy.disabled || sy.value)); }
    // Keuzelijsten gelijkzetten met de gekozen motor; focus alleen na een handeling van de klant
    function show(focus) {
      fillBrands(); fillModels();
      if (focus === 'model') sm.focus(); else if (focus === 'year' && !sy.disabled) sy.focus(); else if (focus === 'brand') sb.focus();
    }

    function scrollToCard() {
      var c = $('[data-pfx-main]');
      if (c && c.getBoundingClientRect().top < 0) c.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function finish() {
      var m = { brand: sel.brand, model: sel.model, year: sel.year || '' }; if (sel.v) m.v = sel.v;
      remember(m); renderGarage();
      track('search', { brand: m.brand, model: m.model, year: m.year || null });
      if (mode !== 'full') { location.href = resultsUrl(m); return; }
      try { history.replaceState(null, '', resultsUrl(Object.assign({}, m)).replace(/^[^?]*/, location.pathname)); } catch (e) {}
      root.classList.add('pfx--chosen');
      show(null);
      results(m);
      setTimeout(function () { var bar = res.querySelector('.pfx-bar'); if (bar) bar.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 60);
    }

    /* ---------- resultaten ---------- */
    var R = null; // huidige resultaat-staat
    function results(m) {
      res.hidden = false; res.innerHTML = '';
      var b = brandInfo(m.brand);
      if (!b) { res.hidden = true; return; }
      res.appendChild(el('div', 'pfx-loading'));
      Promise.all([brandData(b), universal()]).then(function (all) { renderResults(m, b, all[0], all[1]); });
    }

    function renderResults(m, b, d, uni) {
      var entries = entriesFor(d, m);
      var vlist = d.versions || [];
      var yearVers = (d.modelVersions && d.modelVersions[m.model] && d.modelVersions[m.model][m.year]) || [];
      var vSel = m.v ? vlist.map(function (x) { return x[0]; }).indexOf(m.v) : -1;
      var list = Object.keys(entries).map(function (k) { var i = +k; return { p: d.products[i], i: i, vers: entries[k] }; });
      var F = { group: '', type: {}, vendor: {}, color: {}, opt: {}, pos: '', min: null, max: null, stock: false, sale: false, q: '' };
      var openF = { type: true };
      var sort = 'rel', shown = PAGE;
      R = { m: m };
      res.innerHTML = '';

      // motorbalk
      var bar = el('div', 'pfx-bar');
      var bw = el('div', 'pfx-wrap pfx-bar__in');
      var bike = el('div', 'pfx-bar__bike');
      bike.appendChild(el('span', 'pfx-bar__k', t.yourBike));
      var nm = el('div', 'pfx-bar__name'); nm.appendChild(el('strong', null, m.brand + ' ' + m.model));
      if (m.year) nm.appendChild(el('span', 'pfx-bar__year', m.year));
      bike.appendChild(nm);
      var cnt = el('div', 'pfx-bar__count'); var cn = el('b', null, '0'); cnt.appendChild(cn); cnt.appendChild(el('span', null, ' ' + t.fitCount));
      var acts = el('div', 'pfx-bar__acts');
      if (yearVers.length > 1 && list.some(function (x) { return x.vers; })) {
        var vs = el('select', 'pfx-select'); vs.setAttribute('aria-label', t.version);
        var o0 = el('option', null, t.allVersions); o0.value = ''; vs.appendChild(o0);
        yearVers.forEach(function (vi) { var o = el('option', null, vlist[vi][1]); o.value = vlist[vi][0]; if (vi === vSel) o.selected = true; vs.appendChild(o); });
        vs.addEventListener('change', function () {
          var nv = vs.value || undefined; sel.v = nv; m.v = nv; remember(m);
          try { history.replaceState(null, '', resultsUrl(m).replace(/^[^?]*/, location.pathname)); } catch (e) {}
          track('version', { brand: m.brand, model: m.model, year: m.year, v: nv || null });
          vSel = nv ? vlist.map(function (x) { return x[0]; }).indexOf(nv) : -1; draw();
        });
        acts.appendChild(vs);
      }
      var ch = el('button', 'pfx-btn pfx-btn--ghost'); ch.type = 'button'; ch.appendChild(svg(I.edit)); ch.appendChild(el('span', null, t.change));
      ch.addEventListener('click', function () { $('[data-pfx-main]').scrollIntoView({ behavior: 'smooth', block: 'center' }); setTimeout(function () { sm.focus(); }, 400); });
      var sh = el('button', 'pfx-btn pfx-btn--ghost'); sh.type = 'button'; sh.appendChild(svg(I.share)); var shT = el('span', null, t.share); sh.appendChild(shT);
      sh.addEventListener('click', function () {
        var url = location.href;
        if (navigator.share) { navigator.share({ title: label(m), url: url }).catch(function () {}); return; }
        (navigator.clipboard ? navigator.clipboard.writeText(url) : Promise.reject()).then(function () { shT.textContent = t.copied; setTimeout(function () { shT.textContent = t.share; }, 2000); }).catch(function () {});
        track('share', { brand: m.brand, model: m.model });
      });
      acts.appendChild(ch); acts.appendChild(sh);
      bw.appendChild(bike); bw.appendChild(cnt); bw.appendChild(acts); bar.appendChild(bw); res.appendChild(bar);

      var body = el('div', 'pfx-wrap pfx-body'); res.appendChild(body);

      // categorietegels met foto
      var cats = el('div', 'pfx-cats'); body.appendChild(cats);
      // gereedschap
      var tools = el('div', 'pfx-tools');
      var sq = el('label', 'pfx-filterbox pfx-filterbox--in'); sq.appendChild(svg(I.search));
      var sqi = el('input'); sqi.type = 'search'; sqi.placeholder = t.searchIn; sqi.setAttribute('aria-label', t.searchIn); sq.appendChild(sqi);
      var fbtn = el('button', 'pfx-btn pfx-btn--line pfx-tools__f'); fbtn.type = 'button'; fbtn.appendChild(svg(I.filter)); var fbt = el('span', null, t.filters); fbtn.appendChild(fbt);
      var so = el('select', 'pfx-select pfx-select--line'); so.setAttribute('aria-label', t.sort);
      [['rel', t.sortRel], ['low', t.sortLow], ['high', t.sortHigh], ['name', t.sortName]].forEach(function (x) { var o = el('option', null, x[1]); o.value = x[0]; so.appendChild(o); });
      tools.appendChild(sq); tools.appendChild(fbtn); tools.appendChild(so); body.appendChild(tools);
      var pills = el('div', 'pfx-pills'); body.appendChild(pills);
      var grid = el('div', 'pfx-grid'); body.appendChild(grid);
      var more = el('button', 'pfx-btn pfx-btn--line pfx-more', t.more); more.type = 'button'; body.appendChild(more);
      var empty = el('div', 'pfx-empty'); empty.hidden = true; body.appendChild(empty);

      // universeel
      var uniList = (uni && uni.products) || [];
      var uw = null;
      if (uniList.length) {
        uw = el('div', 'pfx-uni');
        var uh = el('div', 'pfx-uni__head'); uh.appendChild(el('h3', 'pfx-h3', t.uniTitle)); uh.appendChild(el('p', 'pfx-muted', t.uniLead));
        var ur = el('div', 'pfx-rail'); uniList.slice(0, 12).forEach(function (p) { ur.appendChild(card(p, null, true)); });
        uw.appendChild(uh); uw.appendChild(ur); body.appendChild(uw);
        refresh(ur.querySelectorAll('.pfx-card'));
      }
      body.appendChild(notFound(m));

      // filterlade
      var drawer = el('div', 'pfx-drawer'); drawer.hidden = true; drawer.setAttribute('role', 'dialog'); drawer.setAttribute('aria-modal', 'true'); drawer.setAttribute('aria-label', t.filters);
      var shade = el('div', 'pfx-drawer__shade');
      var dp = el('div', 'pfx-drawer__panel');
      var dh = el('div', 'pfx-drawer__head'); dh.appendChild(el('h3', 'pfx-h3', t.filters));
      var dx = el('button', 'pfx-iconbtn'); dx.type = 'button'; dx.setAttribute('aria-label', t.close || 'X'); dx.appendChild(svg(I.x)); dh.appendChild(dx);
      var facets = el('div', 'pfx-drawer__body');
      var df = el('div', 'pfx-drawer__foot');
      var dclear = el('button', 'pfx-link', t.clear); dclear.type = 'button';
      var dshow = el('button', 'pfx-btn pfx-btn--red'); dshow.type = 'button';
      df.appendChild(dclear); df.appendChild(dshow);
      dp.appendChild(dh); dp.appendChild(facets); dp.appendChild(df);
      drawer.appendChild(shade); drawer.appendChild(dp); res.appendChild(drawer);
      function openDrawer(o) { drawer.hidden = !o; document.documentElement.classList.toggle('pfx-lock', o); if (o) { buildFacets(); dx.focus(); } }
      fbtn.addEventListener('click', function () { openDrawer(true); });
      dx.addEventListener('click', function () { openDrawer(false); });
      shade.addEventListener('click', function () { openDrawer(false); });
      dshow.addEventListener('click', function () { openDrawer(false); });
      dclear.addEventListener('click', function () { F.type = {}; F.vendor = {}; F.color = {}; F.opt = {}; F.pos = ''; F.min = F.max = null; F.stock = false; F.sale = false; draw(); buildFacets(); });
      drawer.addEventListener('keydown', function (e) { if (e.key === 'Escape') openDrawer(false); });

      // passend bij gekozen uitvoering
      function visibleBase() {
        return list.filter(function (x) { return !(vSel > -1 && x.vers && x.vers.indexOf(vSel) === -1); });
      }
      function pass(x, skip) {
        var p = x.p;
        if (skip !== 'group' && F.group && groupOf(p) !== F.group) return false;
        if (skip !== 'type' && Object.keys(F.type).length && !F.type[p[9] || '-']) return false;
        if (skip !== 'color' && Object.keys(F.color).length && !(p[10] || []).some(function (k) { return F.color[k]; })) return false;
        if (skip !== 'vendor' && Object.keys(F.vendor).length && !F.vendor[p[2] || '-']) return false;
        if (skip !== 'pos' && F.pos && (p[8] || '').indexOf(F.pos) === -1) return false;
        if (F.min != null && p[4] < F.min) return false;
        if (F.max != null && p[4] > F.max) return false;
        if (F.stock && p[7] === 0) return false;
        if (F.sale && !(p[5] && p[5] > p[4])) return false;
        for (var on in F.opt) {
          if (skip === 'o:' + on || !Object.keys(F.opt[on]).length) continue;
          var pv = (p[11] || {})[on] || [];
          if (!pv.some(function (v) { return F.opt[on][v]; })) return false;
        }
        if (F.q && squash(p[1] + ' ' + p[2] + ' ' + (p[9] || p[3])).indexOf(F.q) === -1) return false;
        return true;
      }
      function filtered() {
        var out = visibleBase().filter(function (x) { return pass(x); });
        if (sort === 'low') out.sort(function (a, c) { return a.p[4] - c.p[4]; });
        else if (sort === 'high') out.sort(function (a, c) { return c.p[4] - a.p[4]; });
        else if (sort === 'name') out.sort(function (a, c) { return natural(a.p[1], c.p[1]); });
        else out.sort(function (a, c) { return (c.p[7] !== 0) - (a.p[7] !== 0) || (c.p[6] ? 1 : 0) - (a.p[6] ? 1 : 0); });
        return out;
      }
      function countUp(n) {
        var from = +cn.textContent || 0, t0 = performance.now();
        if (!window.requestAnimationFrame || from === n) { cn.textContent = n; return; }
        (function f(now) { var k = Math.min(1, (now - t0) / 450); cn.textContent = Math.round(from + (n - from) * (1 - Math.pow(1 - k, 3))); if (k < 1) requestAnimationFrame(f); })(t0);
      }
      function drawCats() {
        cats.innerHTML = '';
        var base0 = visibleBase().filter(function (x) { return pass(x, 'group'); });
        var by = {}; base0.forEach(function (x) { var g = groupOf(x.p); (by[g] = by[g] || []).push(x); });
        var ids = Object.keys(by).sort(function (a, c) { return (a === 'overig') - (c === 'overig') || by[c].length - by[a].length; });
        if (ids.length < 2) { cats.hidden = true; return; }
        cats.hidden = false;
        function tile(id, items, name) {
          var b2 = el('button', 'pfx-cat' + ((F.group === id) ? ' is-active' : '')); b2.type = 'button';
          var fig = el('span', 'pfx-cat__img');
          var withImg = items.filter(function (x) { return x.p[6]; }).slice(0, 1)[0];
          if (withImg) { var im = el('img'); im.loading = 'lazy'; im.alt = ''; im.src = imgUrl(withImg.p[6], 240); fig.appendChild(im); }
          b2.appendChild(fig);
          var tx = el('span', 'pfx-cat__txt'); tx.appendChild(el('span', 'pfx-cat__name', name)); tx.appendChild(el('span', 'pfx-cat__n', String(items.length)));
          b2.appendChild(tx);
          b2.addEventListener('click', function () { F.group = F.group === id ? '' : id; shown = PAGE; track('group', { group: F.group || 'alles' }); draw(); });
          cats.appendChild(b2);
        }
        tile('', base0, t.all);
        ids.forEach(function (id) { tile(id, by[id], groupName(id, lg)); });
      }
      function drawPills() {
        pills.innerHTML = '';
        function pill(txt, off) { var p = el('button', 'pfx-pill'); p.type = 'button'; p.appendChild(el('span', null, txt)); p.appendChild(svg(I.x)); p.addEventListener('click', function () { off(); draw(); }); pills.appendChild(p); }
        Object.keys(F.type).forEach(function (k) { pill(k, function () { delete F.type[k]; }); });
        Object.keys(F.vendor).forEach(function (k) { pill(k, function () { delete F.vendor[k]; }); });
        Object.keys(F.color).forEach(function (k) { pill(k, function () { delete F.color[k]; }); });
        Object.keys(F.opt).forEach(function (on) { Object.keys(F.opt[on]).forEach(function (k) { pill(optLabel(on, lg) + ': ' + k, function () { delete F.opt[on][k]; }); }); });
        if (F.sale) pill(t.sale, function () { F.sale = false; });
        if (F.pos) pill(F.pos === 'V' ? t.front : t.rear, function () { F.pos = ''; });
        if (F.min != null || F.max != null) pill(t.price + ': ' + (F.min != null ? money(F.min, ds.locale, ds.currency) : '') + ' – ' + (F.max != null ? money(F.max, ds.locale, ds.currency) : ''), function () { F.min = F.max = null; });
        if (F.stock) pill(t.stock, function () { F.stock = false; });
        var n = pills.children.length;
        if (n > 1) { var c = el('button', 'pfx-link', t.clear); c.type = 'button'; c.addEventListener('click', function () { F.type = {}; F.vendor = {}; F.color = {}; F.opt = {}; F.pos = ''; F.min = F.max = null; F.stock = false; F.sale = false; draw(); }); pills.appendChild(c); }
        pills.hidden = !n;
        fbt.textContent = t.filters + (n ? ' (' + n + ')' : '');
      }
      function draw() {
        var out = filtered();
        countUp(visibleBase().length);
        drawCats(); drawPills();
        grid.innerHTML = '';
        out.slice(0, shown).forEach(function (x) { grid.appendChild(card(x.p, x.vers)); });
        refresh(grid.querySelectorAll('.pfx-card:not([data-done])'));
        more.hidden = out.length <= shown;
        empty.hidden = !!out.length;
        empty.textContent = list.length ? t.noFilter : t.empty;
        dshow.textContent = fmt(t.show, { n: out.length });
      }
      function buildFacets() {
        var keep = facets.scrollTop; facets.innerHTML = '';
        var narrowed = !!(F.group || F.pos || F.stock || F.sale || F.min != null || F.max != null || ['type', 'vendor', 'color'].some(function (k) { return Object.keys(F[k]).length; }) || Object.keys(F.opt).some(function (k) { return Object.keys(F.opt[k]).length; }));
        function selOf(key) { if (key.indexOf('o:') === 0) { var n = key.slice(2); return (F.opt[n] = F.opt[n] || {}); } return F[key]; }
        function opts(key, getter) {
          var c = {}, S = selOf(key);
          visibleBase().filter(function (x) { return pass(x, key); }).forEach(function (x) {
            var v = getter(x.p); (Array.isArray(v) ? v : [v || '-']).forEach(function (k) { c[k] = (c[k] || 0) + 1; });
          });
          Object.keys(S).forEach(function (k) { if (!c[k]) c[k] = 0; });
          var numeric = key.indexOf('o:') === 0 && Object.keys(c).every(function (k) { return k === '-' || /^[Ø\d]/.test(k); });
          return Object.keys(c).filter(function (k) { return k !== '-' && (c[k] > 0 || S[k]); })
            .sort(numeric ? natural : function (a, b2) { return c[b2] - c[a] || natural(a, b2); }).map(function (k) { return [k, c[k]]; });
        }
        // uitklapbare groep; kop toont hoeveel er gekozen is
        function section(key, title, active, build) {
          var g = el('div', 'pfx-facet' + (openF[key] ? ' is-open' : ''));
          var hb = el('button', 'pfx-facet__head'); hb.type = 'button'; hb.setAttribute('aria-expanded', openF[key] ? 'true' : 'false');
          hb.appendChild(el('span', 'pfx-facet__t', title));
          if (active) hb.appendChild(el('span', 'pfx-facet__dot', String(active)));
          hb.appendChild(svg(I.chev, 'pfx-i pfx-facet__chev'));
          var body = el('div', 'pfx-facet__body');
          hb.addEventListener('click', function () { openF[key] = !openF[key]; g.classList.toggle('is-open', openF[key]); hb.setAttribute('aria-expanded', openF[key] ? 'true' : 'false'); });
          var inner = el('div', 'pfx-facet__in'), pad = el('div', 'pfx-facet__pad'); inner.appendChild(pad); body.appendChild(inner);
          g.appendChild(hb); g.appendChild(body); build(pad); facets.appendChild(g);
        }
        function group(title, key, getter) {
          var S = selOf(key), o = opts(key, getter); if (!o.length || (o.length < 2 && !Object.keys(S).length && !narrowed)) return;
          section(key, title, Object.keys(S).length, function (body) {
            var ul = el('div', 'pfx-facet__list');
            o.forEach(function (kv, i) {
              var l = el('label', 'pfx-check'); if (i >= 8) l.hidden = true;
              var cb = el('input'); cb.type = 'checkbox'; cb.checked = !!S[kv[0]];
              cb.addEventListener('change', function () { if (cb.checked) S[kv[0]] = 1; else delete S[kv[0]]; shown = PAGE; track('filter', { key: key, value: kv[0], on: cb.checked }); draw(); buildFacets(); });
              l.appendChild(cb); l.appendChild(el('span', 'pfx-check__box'));
              if (key === 'color') { var sw = el('span', 'pfx-swatch'); sw.dataset.c = kv[0]; l.appendChild(sw); }
              l.appendChild(el('span', 'pfx-check__txt', kv[0])); l.appendChild(el('span', 'pfx-check__n', String(kv[1])));
              ul.appendChild(l);
            });
            body.appendChild(ul);
            if (o.length > 8) { var mb = el('button', 'pfx-link', fmt(t.showAll, { n: o.length })); mb.type = 'button'; mb.addEventListener('click', function () { ul.querySelectorAll('[hidden]').forEach(function (x) { x.hidden = false; }); mb.remove(); }); body.appendChild(mb); }
          });
        }
        group(t.type, 'type', function (p) { return p[9]; });
        group(t.vendor, 'vendor', function (p) { return p[2]; });
        group(t.color, 'color', function (p) { return p[10] || []; });
        var oc = {};
        visibleBase().forEach(function (x) { Object.keys(x.p[11] || {}).forEach(function (n) { oc[n] = (oc[n] || 0) + 1; }); });
        Object.keys(oc).sort(function (a, b2) { var ia = OPT_ORDER.indexOf(a), ib = OPT_ORDER.indexOf(b2); return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib) || oc[b2] - oc[a]; })
          .forEach(function (n) { group(optLabel(n, lg), 'o:' + n, function (p) { return (p[11] || {})[n] || []; }); });
        var vb = visibleBase().filter(function (x) { return pass(x, 'pos'); });
        var nv = vb.filter(function (x) { return (x.p[8] || '').indexOf('V') > -1; }).length, na = vb.filter(function (x) { return (x.p[8] || '').indexOf('A') > -1; }).length;
        if (nv || na) section('pos', t.position, F.pos ? 1 : 0, function (body) {
          var seg = el('div', 'pfx-seg');
          [['', t.all, vb.length], ['V', t.front, nv], ['A', t.rear, na]].forEach(function (s) {
            var b2 = el('button', 'pfx-seg__btn' + (F.pos === s[0] ? ' is-active' : ''), s[1] + ' (' + s[2] + ')'); b2.type = 'button';
            if (s[0] && !s[2]) b2.disabled = true;
            b2.addEventListener('click', function () { F.pos = s[0]; draw(); buildFacets(); }); seg.appendChild(b2);
          });
          body.appendChild(seg);
        });
        var prices = vb.map(function (x) { return x.p[4]; }).filter(function (v) { return v != null; });
        section('price', t.price, (F.min != null || F.max != null) ? 1 : 0, function (body) {
          var pr = el('div', 'pfx-price');
          var lo = prices.length ? Math.floor(Math.min.apply(null, prices)) : 0, hi = prices.length ? Math.ceil(Math.max.apply(null, prices)) : 0;
          [['min', t.from, lo], ['max', t.to, hi]].forEach(function (s) {
            var w = el('label', 'pfx-price__f'); w.appendChild(el('span', null, s[1]));
            var box = el('span', 'pfx-price__box'); box.appendChild(el('span', 'pfx-price__cur', '€'));
            var i2 = el('input'); i2.type = 'number'; i2.inputMode = 'numeric'; i2.min = 0; i2.placeholder = String(s[2]); if (F[s[0]] != null) i2.value = F[s[0]];
            i2.addEventListener('change', function () { F[s[0]] = i2.value === '' ? null : +i2.value; draw(); buildFacets(); });
            box.appendChild(i2); w.appendChild(box); pr.appendChild(w);
          });
          body.appendChild(pr);
        });
        var sg = el('div', 'pfx-facet pfx-facet--switch');
        var sw = el('label', 'pfx-switch'); var si = el('input'); si.type = 'checkbox'; si.checked = F.stock;
        si.addEventListener('change', function () { F.stock = si.checked; draw(); });
        sw.appendChild(el('span', null, t.stock)); sw.appendChild(si); sw.appendChild(el('span', 'pfx-switch__ui'));
        sg.appendChild(sw);
        if (vb.some(function (x) { return x.p[5] && x.p[5] > x.p[4]; })) {
          var sw2 = el('label', 'pfx-switch'); sw2.style.marginTop = '16px'; var si2 = el('input'); si2.type = 'checkbox'; si2.checked = F.sale;
          si2.addEventListener('change', function () { F.sale = si2.checked; draw(); });
          sw2.appendChild(el('span', null, t.sale)); sw2.appendChild(si2); sw2.appendChild(el('span', 'pfx-switch__ui'));
          sg.appendChild(sw2);
        }
        facets.appendChild(sg);
        facets.scrollTop = keep;
      }
      sqi.addEventListener('input', function () { F.q = squash(sqi.value); shown = PAGE; draw(); });
      so.addEventListener('change', function () { sort = so.value; draw(); });
      more.addEventListener('click', function () { shown += PAGE; draw(); });

      function card(p, vers, uniCard) {
        var href = (ds.productBase || '') + '/products/' + p[0];
        var c = el('article', 'pfx-card' + (uniCard ? ' pfx-card--sm' : '')); c.dataset.handle = p[0]; c._p = p;
        var a = el('a', 'pfx-card__media'); a.href = href; a.setAttribute('aria-label', p[1]);
        if (p[6]) { var im = el('img'); im.loading = 'lazy'; im.alt = ''; im.src = imgUrl(p[6], 500); im.srcset = imgUrl(p[6], 320) + ' 320w, ' + imgUrl(p[6], 560) + ' 560w'; im.sizes = '(min-width: 990px) 280px, 46vw'; a.appendChild(im); }
        if (!uniCard) {
          var fit = el('span', 'pfx-fit' + (vers ? ' pfx-fit--check' : '')); fit.appendChild(svg(I.check)); fit.appendChild(el('span', null, vers ? t.checkVersion : t.fits));
          a.appendChild(fit);
        }
        if (p[5] && p[5] > p[4]) { var pct = Math.round((1 - p[4] / p[5]) * 100); if (pct > 0) a.appendChild(el('span', 'pfx-sale', fmt(t.discount, { n: pct }))); }
        if (p[7] === 0) { c.classList.add('is-soldout'); a.appendChild(el('span', 'pfx-soldout', t.soldout)); }
        c.appendChild(a);
        var bd = el('div', 'pfx-card__body');
        if (p[2]) bd.appendChild(el('span', 'pfx-card__vendor', p[2]));
        var ti = el('a', 'pfx-card__title', p[1]); ti.href = href; bd.appendChild(ti);
        if (vers && vers.length) bd.appendChild(el('span', 'pfx-card__note', fmt(t.onlyFor, { v: vers.map(function (i) { return (vlist[i] || ['', ''])[1]; }).filter(Boolean).join(', ') })));
        var foot = el('div', 'pfx-card__foot');
        var pr = el('div', 'pfx-card__price'); pr.appendChild(el('span', 'pfx-card__now', money(p[4], ds.locale, ds.currency)));
        if (p[5] && p[5] > p[4]) pr.appendChild(el('s', 'pfx-card__was', money(p[5], ds.locale, ds.currency)));
        foot.appendChild(pr);
        var add = el('a', 'pfx-add'); add.href = href; add.setAttribute('aria-label', t.view + ': ' + p[1]); add.appendChild(svg(I.arrow));
        foot.appendChild(add); bd.appendChild(foot); c.appendChild(bd);
        [a, ti, add].forEach(function (x) { x.addEventListener('click', function () { clicked(p[0]); }); });
        return c;
      }
      function clicked(h) {
        track('click', { handle: h, brand: m.brand, model: m.model, year: m.year || null });
        var key = 'hvmPfxClicked', c = []; try { c = JSON.parse(sessionStorage.getItem(key) || '[]'); } catch (e) {}
        if (c.indexOf(h) === -1) c.push(h); try { sessionStorage.setItem(key, JSON.stringify(c.slice(-20))); } catch (e) {}
        if (ds.refresh !== 'false') fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { 'Partfinder motor': label(m), 'Partfinder producten': c.join(', ') } }), keepalive: true }).catch(function () {});
      }
      function refresh(cards) {
        cards = Array.prototype.slice.call(cards);
        cards.forEach(function (c) { c.dataset.done = '1'; });
        if (ds.refresh === 'false') return;
        function next() {
          var c = cards.shift(); if (!c) return Promise.resolve();
          return fetch('/products/' + c.dataset.handle + '.js').then(function (r) {
            if (r.status === 404) { c.remove(); return; }
            return r.json().then(function (pd) {
              var price = pd.price / 100, was = pd.compare_at_price ? pd.compare_at_price / 100 : null;
              c._p[4] = price; c._p[7] = pd.available ? 1 : 0;
              c.querySelector('.pfx-card__now').textContent = money(price, ds.locale, ds.currency);
              var w = c.querySelector('.pfx-card__was'); if (w && !(was > price)) w.remove();
              if (!pd.available) c.classList.add('is-soldout');
              if (pd.available && pd.variants && pd.variants.length === 1) {
                var old = c.querySelector('.pfx-add'), btn = el('button', 'pfx-add pfx-add--cart'); btn.type = 'button'; btn.setAttribute('aria-label', t.add + ': ' + pd.title); btn.appendChild(svg(I.plus));
                btn.addEventListener('click', function () {
                  clicked(pd.handle); btn.disabled = true;
                  fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: pd.variants[0].id, quantity: 1 }] }) })
                    .then(function (r2) {
                      if (!r2.ok) throw new Error('cart');
                      btn.classList.add('is-done'); btn.innerHTML = ''; btn.appendChild(svg(I.check)); toast(t.added + ': ' + pd.title);
                      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
                      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
                      setTimeout(function () { btn.classList.remove('is-done'); btn.innerHTML = ''; btn.appendChild(svg(I.plus)); btn.disabled = false; }, 2200);
                    }).catch(function () { location.href = old.href; });
                });
                old.replaceWith(btn);
              }
            });
          }).catch(function () {}).then(next);
        }
        return Promise.all([next(), next(), next(), next()]);
      }
      draw();
      track('results', { brand: m.brand, model: m.model, year: m.year || null, count: list.length });
    }

    function notFound(m) {
      var w = el('div', 'pfx-nf');
      var tx = el('div', 'pfx-nf__txt');
      tx.appendChild(el('h3', 'pfx-h3', t.nfTitle)); tx.appendChild(el('p', null, t.nfLead));
      var chip = el('span', 'pfx-nf__bike'); chip.appendChild(svg(I.check)); chip.appendChild(el('span', null, label(m))); tx.appendChild(chip);
      w.appendChild(tx);
      var acts = el('div', 'pfx-nf__acts');
      var text = fmt(t.nfMsg, { bike: label(m) });
      if (ds.whatsapp) {
        var a = el('a', 'pfx-btn pfx-btn--wa'); a.href = 'https://wa.me/' + ds.whatsapp + '?text=' + encodeURIComponent(text); a.target = '_blank'; a.rel = 'noopener';
        a.appendChild(svg(I.wa)); a.appendChild(el('span', null, t.whatsapp)); a.addEventListener('click', function () { track('nietgevonden', { via: 'whatsapp', brand: m.brand, model: m.model, year: m.year || null }); });
        acts.appendChild(a);
      }
      if (ds.email) {
        var e = el('a', 'pfx-btn pfx-btn--light'); e.href = 'mailto:' + ds.email + '?subject=' + encodeURIComponent(label(m)) + '&body=' + encodeURIComponent(text);
        e.appendChild(svg(I.mail)); e.appendChild(el('span', null, t.email)); e.addEventListener('click', function () { track('nietgevonden', { via: 'email', brand: m.brand, model: m.model, year: m.year || null }); });
        acts.appendChild(e);
      }
      w.appendChild(acts);
      return w;
    }

    var toastEl = null;
    function toast(text) {
      if (!toastEl) { toastEl = el('div', 'pfx-toast'); toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
      toastEl.innerHTML = ''; toastEl.appendChild(svg(I.check)); toastEl.appendChild(el('span', null, text));
      toastEl.classList.add('is-on'); clearTimeout(toastEl._t); toastEl._t = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2400);
    }

    function trust() {
      var ul = $('[data-pfx-trust]'); if (!ul) return;
      [[I.shield, t.trust1], [I.truck, t.trust2], [I.chat, t.trust3]].forEach(function (x) { var li = el('li'); li.appendChild(svg(x[0])); li.appendChild(el('span', null, x[1])); ul.appendChild(li); });
    }

    /* ---------- start ---------- */
    buildSelects(); buildFast(); renderGarage(); trust();
    wiz.parentNode.insertBefore(wiz, wiz.parentNode.firstChild);
    fast.parentNode.insertBefore(el('p', 'pfx-fastlabel', t.fastLabel), fast);
    ready.then(function () {
      var q = new URLSearchParams(location.search);
      var qb = q.get('merk'), qm = q.get('model');
      if (mode === 'full' && qb && qm && brandInfo(qb)) {
        sel = { brand: qb, model: qm, year: q.get('jaar') || '', v: q.get('uitv') || undefined };
        root.classList.add('pfx--chosen'); show(null);
        results(sel); remember(sel); renderGarage();
      } else show(null);
    }).catch(function () { root.classList.add('pfx--error'); });

    root._pfx = { plate: lookupPlate };
  }

  function boot() { document.querySelectorAll('[data-pfx]').forEach(function (r) { if (!r._pfx) App(r); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
